export enum KitchenType {
    CLOSE = 1,
    OPEN = 2
}

export const getKitchenTypeNameWith = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSE:
            return "z kuchnią";
        case KitchenType.OPEN:
            return "z aneksem";
        default:
            return "";
    }
};
export const getKitchenTypeName = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSE:
            return "zamknięta kuchnia";
        case KitchenType.OPEN:
            return "otwarta kuchnia";
        default:
            return "";
    }
};
export enum KitchenType {
    CLOSE = 1,
    OPEN = 2
}

export const getKitchenTypeNameWith = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSE:
            return "z kuchnią";
        case KitchenType.OPEN:
            return "z aneksem";
        default:
            return "";
    }
};
export const getKitchenTypeName = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSE:
            return "zamknięta kuchnia";
        case KitchenType.OPEN:
            return "otwarta kuchnia";
        default:
            return "";
    }
};
